'use client';
import { ReactNode, useEffect, useState } from 'react';
import { StyledTooltip } from '@components/shared/BaseTooltip/styles';
import Message from '@components/shared/BaseTooltip/_Message';

export interface BaseTooltipProps {
  text: string;
  border?: boolean;
  label: string;
  closeIcon?: boolean;
  closeLabel: string;
  children: ReactNode;
  onToggleOpen?: (open: boolean) => void;
}

const BaseTooltip = ({
  text,
  border = false,
  label,
  closeIcon = false,
  closeLabel,
  children,
  onToggleOpen,
}: BaseTooltipProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    onToggleOpen?.(open);
  }, [open, onToggleOpen]);

  return (
    <StyledTooltip
      border={border}
      title={
        <Message text={text} closeIcon={closeIcon} closeLabel={closeLabel} setOpen={setOpen} />
      }
      arrow
      enterTouchDelay={30}
      leaveTouchDelay={0}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      aria-label={label || 'Open Info Dialog'}
      role="tooltip"
      tabIndex={0}
    >
      <span className="tw-cursor-pointer">{children}</span>
    </StyledTooltip>
  );
};

export default BaseTooltip;
